// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"9f5f75d3","149":"d2389679","399":"bb7c55b6","438":"09ed72f6","453":"dcfc9013","640":"0762d4e8","701":"c65df8ca"}[chunkId] + ".chunk.js";
};